module.exports = __webpack_public_path__ + "img/bm-3.d50edcd0.png";